
import { useTranslation } from "react-i18next";

const Vision = () => {
  const { t } = useTranslation(["vision"]);

  // Récupérer les questions avec le bon typage
  const questions = t("innovation.questions", { returnObjects: true }) as string[];

  return (
    <section className="py-24 bg-background">
      <div className="container-custom">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold mb-8 bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-orange text-center leading-[2.6] pb-4">
              {t("title")}
            </h2>
            <p className="text-xl text-muted-foreground mb-8 text-center leading-relaxed max-w-3xl mx-auto">
              {t("description")}
            </p>
          </div>

          <div className="grid gap-12">
            <div className="bg-card rounded-2xl p-8 shadow-lg group border border-border">
              <h3 className="text-2xl font-semibold mb-6 text-brand-orange">
                {t("universalLanguage.title")}
              </h3>
              <p className="text-muted-foreground leading-relaxed text-lg">
                {t("universalLanguage.description")}
              </p>
            </div>

            <div className="bg-card rounded-2xl p-8 shadow-lg group border border-border">
              <h3 className="text-2xl font-semibold mb-6 text-brand-orange">
                {t("innovation.title")}
              </h3>
              <p className="text-muted-foreground leading-relaxed text-lg mb-6">
                {t("innovation.description")}
              </p>
              <ul className="space-y-4">
                {questions.map((question: string, index: number) => (
                  <li key={index} className="text-muted-foreground leading-relaxed">
                    {question}
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-card rounded-2xl p-8 shadow-lg group border border-border">
              <h3 className="text-2xl font-semibold mb-6 text-brand-orange">
                {t("future.title")}
              </h3>
              <p className="text-muted-foreground leading-relaxed text-lg mb-6">
                {t("future.description")}
              </p>
              <p className="text-muted-foreground leading-relaxed text-lg italic">
                {t("future.conclusion")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
